import { render, staticRenderFns } from "./mmi.vue?vue&type=template&id=2aca5873&"
import script from "./mmi.vue?vue&type=script&lang=js&"
export * from "./mmi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports